module.exports = "/assets/3866ca06aed5c485b8ebd8bf80150adc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/8R.png
// module id = 1145
// module chunks = 0